import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../../layouts/sidebarProposal/SidebarProposal'
import BudgetSubproject from '../../../../widgets/budget/BudgetSubproject'
import { getSchemaSubPaymentSaveNew } from '../../../../redux/actions/paymentSave'
import PanalLoadingTemplate from '../../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../../utils/loading'
import ProjectBasicInfoSubProject from '../../../../widgets/projectBasicInfo/ProjectBasicInfoSubProject'
import ContentHeader from '../../../../components/ContentHeader/ContentHeader'
import { cloneDeep } from 'lodash-es'

export default function PaymentSaveSubNew() {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const mode = location.search.substring(1)

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      let _schema = await getSchemaSubPaymentSaveNew(projectId)
      if (mode == '1') {
        _schema.disabled = true
        _schema.forms.budget.disabled = true
      }
      console.log('res ', _schema)
      setSchema(_schema)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  if (error) {
    return (
      <SidebarProposal isNewSubProject>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isNewSubProject>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isNewSubProject>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfoSubProject schema={schema.forms.projectInfo} />
      <br />
      <BudgetSubproject
        schema={schema.forms}
        isEditable={!schema.forms.budget.disabled}
        isEditableBudgetPlan={false}
        disabledSendButton={schema.forms.budget.disabledSendButton}
      />
      <br />
    </SidebarProposal>
  )
}

const mockSchema = {
  header: 'บันทึกงวดเงิน',
  subHeader: 'ข้อเสนอโครงการ ทดสอบ 1',
  projecCode: null,
  projecName: null,
  disabled: false,
  formTemplate: 0,
  forms: {
    projectInfo: {
      projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
      mainProject: {
        header: 'โครงการหลัก',
        projectId: 'C73B82B7-B8FE-414F-AE31-1B4B55991F89',
        versionCode: '9.0',
        projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
        projectNameTitle: 'ชื่อโครงการ',
        projectName: 'ทดสอบอนุมัติหลายโครงการ 002',
        projectCodeTitle: 'รหัสโครงการ',
        projectCode: '66-00018',
        projectTypeTitle: 'ประเภทโครงการ',
        projectType: 'โครงการพัฒนาและปฏิบัติการ',
        projectProposalTypeTitle: 'ประเภทข้อเสนอโครงการ',
        projectProposalType: 'โครงการ',
        statusTitle: 'สถานะ',
        status: 'ดำเนินการ',
        projectProposalStyleTitle: 'ลักษณะข้อเสนอโครงการ',
        projectProposalStyle: 'โครงการใหม่()',
        ownerNameTitle: 'ผู้ยื่นข้อเสนอ',
        ownerName: null,
        activityTypeTitle: 'ลักษณะกิจกรรม',
        activityTypeTitle2: '(ประเภทโครงการ)',
        activityType: 'โครงการพัฒนาและปฏิบัติการ',
      },
      subProject: {
        header: 'โครงการย่อย',
        projectId: '724E3DA9-EA86-41BD-B8B2-640F5553A319',
        versionCode: '1.0',
        projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
        projectNameTitle: 'ชื่อโครงการ',
        projectName: 'ทดสอบ 1',
        projectCodeTitle: 'รหัสโครงการ',
        projectCode: '66-00018-01',
        projectTypeTitle: 'ประเภทโครงการ',
        projectType: 'โครงการพัฒนาและปฏิบัติการ',
        projectProposalTypeTitle: 'ประเภทข้อเสนอโครงการ',
        projectProposalType: 'โครงการ',
        statusTitle: 'สถานะ',
        status: 'กลั่นกรอง',
        projectProposalStyleTitle: 'ลักษณะข้อเสนอโครงการ',
        projectProposalStyle: 'โครงการใหม่()',
        ownerNameTitle: 'ผู้ยื่นข้อเสนอ',
        ownerName: 'นางสาว ทดสอบ ทดสอบ',
        activityTypeTitle: 'ลักษณะกิจกรรม',
        activityTypeTitle2: '(ประเภทโครงการ)',
        activityType: 'โครงการพัฒนาและปฏิบัติการ',
      },
    },
    masterCategoryOfCost: [
      {
        id: '5FBC74DB-E97E-4D18-8483-75200649DC25',
        name: 'งวดที่ 1',
      },
      {
        id: '93C80E78-2E73-42C4-968E-9E3D7CB9FB7F',
        name: 'งวดที่ 2',
      },
      {
        id: 'F2C0CE6E-2818-49DC-AF30-B7CA6E2F91CC',
        name: 'งวดที่ 3',
      },
      {
        id: '281EE993-F4D2-4D3C-A938-73B241DBB031',
        name: 'งวดที่ 4',
      },
      {
        id: '4022552C-73A4-43EB-BE2A-0C192E242C1F',
        name: 'งวดที่ 5',
      },
      {
        id: 'C335DF1C-D4FA-459F-A4B5-0B02D118451A',
        name: 'งวดที่ 6',
      },
      {
        id: '59321410-BB4D-4232-A10A-4EEC1969A178',
        name: 'งวดที่ 7',
      },
      {
        id: '49963A0F-EF7B-4CCF-8E4B-017397E92789',
        name: 'งวดที่ 8',
      },
      {
        id: 'A9B235D0-E315-4605-8C47-BBE96B79E8A3',
        name: 'งวดที่ 9',
      },
      {
        id: '269845E0-A538-432E-BA81-DC1BD2296E5F',
        name: 'งวดที่ 10',
      },
    ],
    masterCategoryCost: [
      {
        id: 'F893CBBD-0178-4F1B-BA0D-AD9F41754F70',
        list: 'รายละเอียดผลงาน',
        children: [
          {
            id: '15ABC0C2-01F1-48A3-9EB5-844692418D8D',
            list: null,
            withholdingTax: 0.0,
            cost: 0.0,
            isDetail: true,
            children: null,
          },
        ],
      },
    ],
    budget: {
      disabled: false,
      budgetSummaryHeader: 'งบประมาณโครงการ',
      periodExpensesHeader: null,
      totalMasterBudget: 0.0,
      totalBudget: 0.0,
      projectStartDate: '10/03/2023',
      projectEndDate: '10/03/2024',
      periodExpensesData: [
        {
          id: '5FBC74DB-E97E-4D18-8483-75200649DC25',
          list: 'งวดที่ 1',
          numberOfInstallment: 1,
          cost: 0.0,
          startDate: '10/03/2023',
          endDate: '10/10/2023',
          date: '10/10/2023',
          year: '2567',
          status: null,
          isNewVersion: true,
          children: [
            {
              id: 'F893CBBD-0178-4F1B-BA0D-AD9F41754F70',
              list: 'รายละเอียดผลงาน',
              withholdingTax: 0.0,
              cost: 0.0,
              isDetail: false,
              children: [
                {
                  id: '15ABC0C2-01F1-48A3-9EB5-844692418D8D',
                  list: '** รายละเอียดงวดงาน มีคำที่ใช้ default  ไว้ รอนักวิขาการส่งมาให้ ',
                  withholdingTax: 0.0,
                  cost: 0.0,
                  isDetail: true,
                  children: [],
                },
              ],
            },
          ],
        },
        {
          id: '93C80E78-2E73-42C4-968E-9E3D7CB9FB7F',
          list: 'งวดที่ 2',
          numberOfInstallment: 2,
          cost: 0.0,
          startDate: '11/10/2023',
          endDate: '10/01/2024',
          date: '10/01/2024',
          year: '2567',
          status: null,
          isNewVersion: true,
          children: [
            {
              id: 'F893CBBD-0178-4F1B-BA0D-AD9F41754F70',
              list: 'รายละเอียดผลงาน',
              withholdingTax: 0.0,
              cost: 0.0,
              isDetail: false,
              children: [
                {
                  id: '15ABC0C2-01F1-48A3-9EB5-844692418D8D',
                  list: '** รายละเอียดงวดงาน มีคำที่ใช้ default  ไว้ รอนักวิขาการส่งมาให้ ',
                  withholdingTax: 0.0,
                  cost: 0.0,
                  isDetail: true,
                  children: [],
                },
              ],
            },
          ],
        },
      ],
    },
  },
}
